import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import './App.css';
import TopBar from './components/TopBar';
import Profile from './components/Profile';
import Publication from './components/Publications';
import Research from './components/Research';
import Footer from './components/Footer';
import ProfileSummary from "./components/ProfileSummary";
import Project from "./components/Project";
import About from "./components/About";
import {Container} from 'reactstrap';
import {Row, Col } from 'react-bootstrap';
import Andry from "./images/Andry.jpg";


class App extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Router basename="/myhome">   
      <div className='App'>
        <div className='header_div'>
        <Container >
            <Row style={{margin:"0px"}}>
              <Col md={{ span: 2}} >
                <img src={Andry} alt={Andry} style={{width:"100%"}}/>
              </Col>
              <Col md={{ span: 10}} style={{verticalAlign: "middle"}}>
              <div className="header_h2">Dr. Andry Rajoelimanana</div>
              </Col>
            </Row>
            </Container>
            </div>
           <TopBar/>
           <ProfileSummary/>
           <Route exact={true} path='/' component={Profile} />
           <Route path='/home' component={Profile} />
           <Route path='/research' component={Research} />
           <Route path='/publications' component={Publication} />
           <Route path='/profile' component={Profile} />
           <Route path='/project' component={Project} />
           <Route path='/contact' component={About}/>

        <Footer/>
      </div>
      </Router> 
    );
  }
}


export default App;
